export const styles={
    title:"800px:text-[25px]  text-[20px] text-black  font-semibold font-poppins text-center py-2",
    label:"text-[16px] font-poppins text-black",
    input:"w-full text:black  bg-white border border-[#0975DE] h-[40px] px-2 outline-none mt-[10px] font-poppins ",
    button:"flex flex-row justify-center items-center py-1 px-6 rounded-lg cursor-pointer bg-blue-950 min-h-[45px] w-full text-[16px] font-poppins text-white font-semibold"
}